import { useUser } from "@/api/users"
import Loader from "@/components/layout/loader"
import { Navigate, useLocation } from "react-router-dom"

interface UserHasWalletProps {
  children: React.ReactNode;
}

export default function UserIsReady({ children }: UserHasWalletProps) {
  const { user, canReceivePayments: walletReady } = useUser()
  const { pathname } = useLocation()

  if (!user) {
    return <Loader message="Loading user..." />
  }

  if (!walletReady) {
    return <Navigate to={`/onboarding?next=${pathname}`} />
  }

  return children
}
